import React from 'react';
import { useParams } from 'react-router-dom';
import ProductLandingPageContent from './content';
import { PageContextProvider } from './context';

const ProductLandingPage = () => {
  const { virtualPhoneNumber } = useParams();
  return (
    <PageContextProvider virtualPhoneNumber={virtualPhoneNumber}>
      <ProductLandingPageContent />
    </PageContextProvider>
  );
};

export default ProductLandingPage;
